import { useEffect } from 'react';

interface ToastProps {
  message: string;
  onClose: () => void;
  duration?: number;
}

export function Toast({ message, onClose, duration = 3000 }: ToastProps) {
  useEffect(() => {
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [onClose, duration]);

  return (
    <div className="fixed bottom-5 left-1/2 z-[1000] -translate-x-1/2 rounded-lg bg-gray-800 px-6 py-3 text-sm text-white shadow-lg animate-[slideUp_300ms_ease-out]">
      <i className="fa fa-check-circle mr-2" />
      {message}
    </div>
  );
}
